(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches || /[?&]bmshot\b/.test(location.search);

  // Header: scroll state + mobile menu
  const header = document.querySelector('.bm-header');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const burger = header.querySelector('.bm-burger');
    const setOpen = (open) => {
      header.classList.toggle('is-open', open);
      burger?.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger?.addEventListener('click', () => setOpen(!header.classList.contains('is-open')));
    header.querySelectorAll('.bm-mobile a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && setOpen(false));

    // Mega menus (Sistemler, Obenan): click/keyboard toggle, one open at a time (hover handled in CSS)
    const megas = [...header.querySelectorAll('.bm-nav__item--mega')];
    const setMega = (item, open) => {
      item.classList.toggle('is-open', open);
      item.querySelector('.bm-nav__trigger')?.setAttribute('aria-expanded', String(open));
    };
    megas.forEach((item) => {
      item.querySelector('.bm-nav__trigger')?.addEventListener('click', () => {
        const open = !item.classList.contains('is-open');
        megas.forEach((m) => m !== item && setMega(m, false));
        setMega(item, open);
      });
      item.addEventListener('mouseenter', () => megas.forEach((m) => m !== item && setMega(m, false)));
    });
    document.addEventListener('click', (e) => megas.forEach((m) => !m.contains(e.target) && setMega(m, false)));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && megas.forEach((m) => setMega(m, false)));
  }

  // Reveal on scroll: plain rect checks, so it works even where IntersectionObserver is unreliable
  const pending = new Set(document.querySelectorAll('.bm-reveal, .bm-journey, .bm-switch--grid, .bm-rdemo__stage'));
  const reveal = () => {
    const limit = window.innerHeight * 0.92;
    pending.forEach((el) => {
      if (el.getBoundingClientRect().top < limit) {
        el.classList.add('is-in');
        el.dispatchEvent(new CustomEvent('bm:in'));
        pending.delete(el);
      }
    });
    if (!pending.size) window.removeEventListener('scroll', onScrollReveal);
  };
  let ticking = false;
  const onScrollReveal = () => {
    if (ticking) return;
    ticking = true;
    // setTimeout, not requestAnimationFrame: rAF pauses in background tabs and embedded panes
    setTimeout(() => { ticking = false; reveal(); }, 40);
  };
  if (reduced) setTimeout(() => pending.forEach((el) => { el.classList.add('is-in'); el.dispatchEvent(new CustomEvent('bm:in')); }));
  else {
    // Run after the rest of this file so bm:in listeners below are attached first
    setTimeout(reveal, 0);
    window.addEventListener('scroll', onScrollReveal, { passive: true });
    window.addEventListener('resize', onScrollReveal);
    // Anchor jumps (#sektor-...) land mid-page: reveal everything above as well
    window.addEventListener('hashchange', () => setTimeout(reveal, 50));
  }

  // Hero AI chat: rotate assistants and type the answer
  document.querySelectorAll('.bm-chat').forEach((chat) => {
    const tabs = [...chat.querySelectorAll('.bm-chat__tab')];
    const answer = chat.querySelector('.bm-chat__a');
    const text = answer?.dataset.text || '';
    if (!tabs.length || !answer) return;

    let index = 0;
    let timer;
    const type = (done) => {
      chat.classList.remove('is-answered');
      if (reduced) { answer.textContent = text; chat.classList.add('is-answered'); return done(); }
      let i = 0;
      answer.innerHTML = '<span class="bm-cursor"></span>';
      const step = () => {
        i += 1;
        answer.innerHTML = text.slice(0, i) + '<span class="bm-cursor"></span>';
        if (i < text.length) timer = setTimeout(step, 28);
        else { answer.textContent = text; chat.classList.add('is-answered'); done(); }
      };
      timer = setTimeout(step, 450);
    };
    const show = (n) => {
      clearTimeout(timer);
      index = n;
      tabs.forEach((t, k) => t.classList.toggle('is-active', k === n));
      type(() => { if (!reduced) timer = setTimeout(() => show((index + 1) % tabs.length), 4200); });
    };
    tabs.forEach((t, k) => t.addEventListener('click', () => show(k)));
    show(0);
  });

  // Journey: set column count for the timeline
  document.querySelectorAll('.bm-journey').forEach((list) => list.style.setProperty('--n', list.children.length));

  // Before / after compare: manual toggle + gentle auto-play until the visitor interacts
  document.querySelectorAll('[data-bm-compare]').forEach((box) => {
    const buttons = [...box.querySelectorAll('[data-state]')];
    let auto;
    const set = (after) => {
      box.classList.toggle('is-after', after);
      buttons.forEach((b) => {
        const on = (b.dataset.state === 'after') === after;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', String(on));
      });
    };
    buttons.forEach((b) => b.addEventListener('click', () => { clearInterval(auto); set(b.dataset.state === 'after'); }));
    box.addEventListener('bm:in', () => {
      if (reduced) return set(true);
      setTimeout(() => set(true), 900);
      auto = setInterval(() => set(!box.classList.contains('is-after')), 4200);
    }, { once: true });
  });

  // Review demo: type the drafted reply, then walk the approval flow
  document.querySelectorAll('[data-bm-review]').forEach((stage) => {
    const p = stage.querySelector('.bm-rdemo__reply p');
    const steps = [...stage.querySelectorAll('.bm-rdemo__flow span')];
    const text = p?.dataset.text || '';
    if (!p) return;
    if (!reduced) p.textContent = '';
    stage.addEventListener('bm:in', () => {
      if (reduced) { steps.forEach((s) => s.classList.add('is-on')); return; }
      let i = 0;
      const tick = () => {
        i += 2;
        p.innerHTML = text.slice(0, i) + '<span class="bm-cursor"></span>';
        if (i < text.length) setTimeout(tick, 22);
        else {
          p.textContent = text;
          steps.forEach((s, k) => setTimeout(() => s.classList.add('is-on'), 400 + k * 600));
        }
      };
      setTimeout(tick, 1400);
    }, { once: true });
  });

  // Growth analysis quiz: one question at a time, auto-advance on answer
  document.querySelectorAll('.bm-analysis__form').forEach((form) => {
    const steps = [...form.querySelectorAll('[data-quiz-step]')];
    if (!steps.length) return;
    const fill = form.querySelector('.bm-quiz__fill');
    const current = form.querySelector('[data-quiz-current]');
    const prev = form.querySelector('[data-quiz-prev]');
    const next = form.querySelector('[data-quiz-next]');
    let index = 0;
    form.classList.add('bm-quiz-js');
    const show = (n) => {
      index = Math.max(0, Math.min(n, steps.length - 1));
      steps.forEach((s, k) => s.classList.toggle('is-active', k === index));
      if (current) current.textContent = index + 1;
      if (fill) fill.style.width = ((index + 1) / steps.length) * 100 + '%';
      if (prev) prev.style.visibility = index === 0 ? 'hidden' : 'visible';
      if (next) next.style.visibility = index === steps.length - 1 ? 'hidden' : 'visible';
    };
    form.addEventListener('change', (e) => {
      if (e.target.type === 'radio') setTimeout(() => show(index + 1), 280);
    });
    prev?.addEventListener('click', () => show(index - 1));
    next?.addEventListener('click', () => show(index + 1));
    show(0);
  });

  // Video: silent loop as a teaser; the play button restarts it from 0 with sound and controls
  document.querySelectorAll('[data-bm-video]').forEach((box) => {
    const video = box.querySelector('video');
    const play = box.querySelector('.bm-vid__play');
    if (!video || !play) return;
    // Start the silent teaser when the box scrolls into view (same trigger as the reveal animation)
    box.addEventListener('bm:in', () => { if (!reduced && !box.classList.contains('is-playing')) video.play().catch(() => {}); });
    if (!reduced && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => entries.forEach((e) => {
        if (box.classList.contains('is-playing')) return;
        if (e.isIntersecting) video.play().catch(() => {}); else video.pause();
      }), { threshold: 0.35 }).observe(video);
    }
    play.addEventListener('click', () => {
      box.classList.add('is-playing');
      video.loop = false;
      video.muted = false;
      video.controls = true;
      video.currentTime = 0;
      video.play().catch(() => {});
    });
  });
})();

/* Card grids: stretch the last card across empty cells so no blank tile remains */
(function () {
  var grids = document.querySelectorAll('.bm-cards');
  if (!grids.length) return;
  function fill() {
    grids.forEach(function (g) {
      var items = g.children, n = items.length;
      if (!n) return;
      var last = items[n - 1];
      last.style.gridColumn = '';
      var cols = getComputedStyle(g).gridTemplateColumns.split(' ').filter(Boolean).length;
      var rest = n % cols;
      if (cols > 1 && rest) last.style.gridColumn = 'span ' + (cols - rest + 1);
    });
  }
  fill();
  var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fill, 120); });
})();

/* Landing page: sticky CTA shows after the hero, hides while the form is visible */
(function () {
  var bar = document.querySelector('[data-bm-sticky]');
  if (!bar) return;
  var hero = document.querySelector('.bm-lp-hero');
  var form = document.querySelector('.bm-form');
  var t;
  function update() {
    var y = window.scrollY, vh = window.innerHeight;
    var past = hero ? y > hero.offsetTop + hero.offsetHeight - vh * 0.3 : y > 400;
    var formOn = false;
    if (form) { var r = form.getBoundingClientRect(); formOn = r.top < vh && r.bottom > 0; }
    bar.classList.toggle('is-on', past && !formOn);
  }
  window.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 60); }, { passive: true });
  update();
})();

/* Landing pop-up form: opens after N seconds, closes to a side tab, never nags after a submit */
(function () {
  var pop = document.querySelector('[data-bm-pop]');
  var tab = document.querySelector('[data-bm-pop-open]');
  if (!pop || !tab) return;
  var store = function (kind, key, val) {
    try { var s = window[kind]; if (val === undefined) return s.getItem(key); s.setItem(key, val); } catch (e) { return null; }
  };
  var push = function (ev) { try { (window.dataLayer = window.dataLayer || []).push({ event: ev }); } catch (e) {} };
  var lastFocus = null;
  var posted = /[?&]contact_posted=true/.test(location.search);
  var postedHere = posted && location.hash === '#bm-popup-form';
  if (posted) store('localStorage', 'bm_lead_done', '1');
  var done = store('localStorage', 'bm_lead_done') === '1';

  function open(auto) {
    lastFocus = document.activeElement;
    pop.hidden = false;
    requestAnimationFrame(function () { pop.classList.add('is-open'); });
    document.documentElement.classList.add('bm-pop-lock');
    tab.hidden = true;
    var first = pop.querySelector('input:not([type=hidden]), button');
    if (first && !auto) setTimeout(function () { first.focus(); }, 250);
    push(auto ? 'bm_popup_auto_open' : 'bm_popup_open');
  }
  function close() {
    pop.classList.remove('is-open');
    document.documentElement.classList.remove('bm-pop-lock');
    setTimeout(function () { pop.hidden = true; }, 250);
    store('sessionStorage', 'bm_pop_closed', '1');
    if (!done) tab.hidden = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  pop.addEventListener('click', function (e) { if (e.target.closest('[data-bm-pop-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
  tab.addEventListener('click', function () { open(false); });
  document.querySelectorAll('.bm-form').forEach(function (f) {
    f.addEventListener('submit', function () { store('localStorage', 'bm_lead_done', '1'); push('bm_lead_submit'); });
  });

  if (postedHere) { open(false); return; }            // show the thank-you inside the pop-up
  if (done) return;                                      // already a lead: no pop-up, no tab
  if (/[?&]bmshot\b/.test(location.search)) { tab.hidden = false; return; }
  if (store('sessionStorage', 'bm_pop_closed') === '1') { tab.hidden = false; return; }

  var delay = (parseFloat(pop.getAttribute('data-delay')) || 5) * 1000;
  function busyWithPageForm() {
    var a = document.activeElement;
    if (a && a.closest && a.closest('.bm-form') && !a.closest('[data-bm-pop]')) return true;
    var main = document.querySelector('.bm-cta .bm-form');
    if (!main) return false;
    var r = main.getBoundingClientRect();
    return r.top < window.innerHeight * 0.8 && r.bottom > window.innerHeight * 0.2;
  }
  function tryOpen() {
    if (busyWithPageForm()) { tab.hidden = false; setTimeout(tryOpen, 4000); return; }
    open(true);
  }
  setTimeout(tryOpen, delay);
})();

/* Lead success: one conversion event per submit, for GTM / Meta Pixel / GA4 if present */
(function () {
  var ok = document.querySelector('[data-bm-lead-success]');
  if (!ok) return;
  try { if (sessionStorage.getItem('bm_lead_tracked') === location.href) return; sessionStorage.setItem('bm_lead_tracked', location.href); } catch (e) {}
  var src = ok.getAttribute('data-source') || '';
  try { (window.dataLayer = window.dataLayer || []).push({ event: 'bm_lead_success', lead_source: src }); } catch (e) {}
  try { if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_name: src }); } catch (e) {}
  try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', { lead_source: src }); } catch (e) {}
})();

/* Reading route: remember finished pages, mark this one complete when its end is reached */
(function () {
  var el = document.querySelector('[data-bm-next]');
  if (!el) return;
  var key = el.getAttribute('data-handle');
  var steps = (el.getAttribute('data-steps') || '').split(',').filter(Boolean);
  var read = [];
  try { read = JSON.parse(localStorage.getItem('bm_read') || '[]'); } catch (e) {}
  var bar = el.querySelector('.bm-next__bar span');
  var count = el.querySelector('[data-bm-next-count]');
  function paint() {
    var n = 0;
    steps.forEach(function (h) {
      var on = read.indexOf(h) > -1; if (on) n++;
      var dot = el.querySelector('.bm-next__dots li[data-h="' + h + '"]');
      if (dot) dot.classList.toggle('is-read', on);
    });
    if (bar) bar.style.setProperty('--p', (n / steps.length * 100) + '%');
    if (count) count.textContent = !n ? '' : (n === steps.length ? count.getAttribute('data-done') : (count.getAttribute('data-progress') || '').replace('[n]', n).replace('[total]', steps.length));
    el.classList.toggle('is-route-done', n === steps.length);
  }
  function complete() {
    if (el.classList.contains('is-complete')) return;
    if (read.indexOf(key) < 0) { read.push(key); try { localStorage.setItem('bm_read', JSON.stringify(read)); } catch (e) {} }
    el.classList.add('is-complete');
    paint();
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'bm_chapter_complete', page: key }); } catch (e) {}
  }
  paint();
  if (read.indexOf(key) > -1) { el.classList.add('is-complete'); }
  var t;
  function check() { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight * 0.85) complete(); }
  window.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(check, 80); }, { passive: true });
  check();
})();
